import { Route, Routes } from 'react-router-dom';
import PublicHeader from '../component/public/PublicHeader';
import PublicFooter from '../component/public/PublicFooter';
import Home from '../page/Home/Home';
import Verify from '../page/Home/Verify';

const HomeLayout = () => {
    return (
        <div className="public-shell flex min-h-screen flex-col">
            <PublicHeader />
            <main className="flex-1">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/verify/:id" element={<Verify />} />
                </Routes>
            </main>
            <PublicFooter />
        </div>
    );
};

export default HomeLayout;
